<template>
  <div>
    <!-- O kancelarii -->
    <v-row id="o-kancelarii">
      <v-col>
        <h1 class="text-center">O Kancelarii</h1>
      </v-col>
    </v-row>
    <v-row class="home-text">
      <v-col md="6">
        <p>
          Poszukując pomocy prawnej na pewno zdajesz sobie sprawę, że<span
            >&nbsp;</span
          ><b>wyb&oacute;r odpowiedniego doradcy</b><span>&nbsp;</span>to często
          jeden z kluczowych element&oacute;w dla powodzenia Twojego
          przedsięwzięcia. Jeśli szukasz prawnik&oacute;w sprzedających swoje
          usługi, znajdziesz ich setki. My sprzedajemy Ci<span>&nbsp;</span
          ><b>bezpieczeństwo prawne i komfort</b>. Dynamika warunk&oacute;w
          gospodarczych w kt&oacute;rych przyszło nam funkcjonować wymaga
          wiedzy, doświadczenia i nieustannej uwagi. Mamy tego świadomość i
          dlatego jesteśmy dla Ciebie partnerem na każdym etapie Twoich
          działań.<span>&nbsp;</span
          ><b
            >Wierzymy, że Tw&oacute;j sukces jest jednocześnie naszym
            sukcesem</b
          >.
        </p>
        <p>
          Jesteśmy grupą prawnik&oacute;w, kt&oacute;rzy zdobywali swoje
          doświadczenie zar&oacute;wno w międzynarodowych korporacjach,
          niewielkich firmach, jak i w administracji publicznej.
        </p>
        <p>
          <b>Specjalizujemy się obsłudze prawnej przedsiębiorc&oacute;w</b>.
          Szczeg&oacute;lnie wspieramy wykonawc&oacute;w zam&oacute;wień
          publicznych i branżę kreatywną. Zr&oacute;żnicowane kompetencje
          naszych ekspert&oacute;w pozwalają nam jednak świadczyć najwyższej
          jakości usługi także w innych dziedzinach.
        </p>
      </v-col>
      <v-col md="6" class="text-left">
        <v-img
          class="round-corners"
          src="../assets/images/do-something-great.jpg"
          max-width="100%"
          contain
          data-aos="fade-left"
        />
      </v-col>
    </v-row>

    <!-- O mnie -->
    <v-row id="o-mnie">
      <v-col>
        <h1 class="text-center">O mnie</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" class="text-left">
        <v-img
          class="round-corners"
          src="../assets/images/DMichalakFoto.jpg"
          max-width="100%"
          contain
          data-aos="fade-right"
        />
      </v-col>
      <v-col md="6" class="o-mnie__text">
        <p>
          Nazywam się<span>&nbsp;</span
          ><b
            >Damian Michalak i jestem radcą prawnym wspierającym
            przedsiębiorc&oacute;w w najważniejszych obszarach ich biznesu</b
          >.
        </p>
        <p>
          Specjalizuję się w<span>&nbsp;</span
          ><b>prawie zam&oacute;wień publicznych</b><span>&nbsp;</span>pomagając
          wykonawcom wygrywać przetargi, a zamawiającym dokonywać mądrych
          zakup&oacute;w w zgodzie z przepisami prawa. Wspieram także<span
            >&nbsp;</span
          ><b>branżę kreatywną</b><span>&nbsp;</span>i jestem zaufanym doradcą
          firm, kt&oacute;re rozumieją jak istotne jest bezpieczeństwo prawne
          ich działalności. Swoim doświadczeniem dzielę się podczas szkoleń, a
          także jako wykładowca specjalistycznych kurs&oacute;w i studi&oacute;w
          podyplomowych oraz autor branżowych publikacji.
        </p>
        <p>
          Swoją kancelarię prowadzę od 2013 r. i jest to fantastyczna przygoda.
          Wierzę i Ty możesz zostać jej uczestnikiem. Zachęcam Cię więc do
          zapoznania się z naszymi obszarami praktyki i zapraszam do
          wsp&oacute;łpracy.
        </p>
      </v-col>
    </v-row>

    <!-- Doświadczenie -->
    <dm-experience class="mt-12" />

    <!-- Blogi -->
    <dm-blogs class="mt-12" />

    <!-- Kontakt -->
    <dm-contact class="mt-12" />
  </div>
</template>

<script>
import DmExperience from '@/components/Experience.vue';
import DmBlogs from '@/components/Blogs.vue';
import DmContact from '@/components/Contact.vue';

export default {
  name: 'Home',
  components: {
    DmExperience,
    DmBlogs,
    DmContact,
  },
};
</script>

<style scoped>
.home-text {
  text-align: justify;
}
.o-mnie__text {
  text-align: justify;
}
</style>
